function initializePageArticleList(sectionId) {
  const section = document.querySelector(`[data-page-article-list="${sectionId}"]`);
  if (!section) return;

  const items = Array.from(section.querySelectorAll('.page__content'));
  const pagination = section.querySelector('.page-article-pagination');
  const pagesWrap = pagination ? pagination.querySelector('.pages') : null;
  const prevLink = pagination ? pagination.querySelector('.prev a') : null;
  const nextLink = pagination ? pagination.querySelector('.next a') : null;
  const perPage = Number(section.dataset.perPage || 10);

  if (!pagination || !pagesWrap || !prevLink || !nextLink) return;

  if (items.length === 0 || items.length <= perPage) {
    pagination.classList.add('hidden');
    items.forEach((item) => {
      item.hidden = false;
    });
    return;
  }

  let currentPage = 1;
  const totalPages = Math.ceil(items.length / perPage);

  const renderPageButtons = () => {
    let html = '';

    for (let i = 1; i <= totalPages; i += 1) {
      html += `<button class="page-article-pagination-btn${i === currentPage ? ' active' : ''}" data-page="${i}" type="button">${i}</button>`;
    }

    pagesWrap.innerHTML = html;
  };

  const renderItems = () => {
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = startIndex + perPage;

    items.forEach((item, index) => {
      item.hidden = !(index >= startIndex && index < endIndex);
    });
  };

  const updateControls = () => {
    prevLink.classList.toggle('disabled', currentPage === 1);
    nextLink.classList.toggle('disabled', currentPage === totalPages);
  };

  const render = () => {
    renderItems();
    renderPageButtons();
    updateControls();
    pagination.classList.remove('hidden');
  };

  prevLink.addEventListener('click', (event) => {
    event.preventDefault();
    if (currentPage === 1) return;
    currentPage -= 1;
    render();
  });

  nextLink.addEventListener('click', (event) => {
    event.preventDefault();
    if (currentPage === totalPages) return;
    currentPage += 1;
    render();
  });

  pagesWrap.addEventListener('click', (event) => {
    const button = event.target.closest('[data-page]');
    if (!button) return;

    const targetPage = Number(button.dataset.page);
    if (!targetPage || targetPage === currentPage) return;

    currentPage = targetPage;
    render();
  });

  render();
}
